import React from "react";
import { useNavigate } from "react-router-dom";
import ApproveVolunteerList from "../../components/DashboardInfo/ApproveVolunteerList";
import { ThemButton } from "../../components/Login/Login.style";
import { MainDiv } from "../../components/Profile/Profile.style";
import { SearchAddDiv } from "../../components/style/Table.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const ApproveVolunteerPage = () => {
  const navigate = useNavigate();
  const moveDashboard = () => {
    navigate("/");
  };
  return (
    <MainDiv>
      <SearchAddDiv>
        <VolunteerHeading>Approved Volunteer Report</VolunteerHeading>
        <div
          style={
            {
              // display: "flex",
              // justifyContent: "center",
            }
          }
        >
          <ThemButton onClick={() => moveDashboard()}>
            Back to dashboard
          </ThemButton>
        </div>
      </SearchAddDiv>
      <ApproveVolunteerList />
    </MainDiv>
  );
};

export default ApproveVolunteerPage;
